/* eslint-disable */

import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ModalPopupMessage from '../modal/ModalPopupMessage';
import './Footer.css';
import meya_logo from '../../assets/images/logo_meya.png';

function Footer(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });


  async function security_protection(mode) {
    if (mode === 'seller' || mode === 'buyer') {
      if (props.permitdata.token === '') {
        if (location.pathname === '' || location.pathname === '/') {
          setModal_popup({
            modaltype: 'modal-info',
            headers: 'กรุณาสมัครสมาชิก',
            message:
              'การซื้อขายสินค้าบน แพล๊ตฟอร์ม มียานั้น ผู้ใช้งานจะต้องลงทะเบียนก่อนเริ่มทำการซื้อขาย',
            enable: true,
          });
        } else {
          setModal_popup({
            modaltype: 'modal-signup',
            headers: 'กรุณาสมัครสมาชิก',
            message:
              'การซื้อขายสินค้าบน แพล๊ตฟอร์ม มียานั้น ผู้ใช้งานจะต้องลงทะเบียนก่อนเริ่มทำการซื้อขาย',
            enable: true,
          });
        }
      } else {
        if (mode === 'seller') {
          navigate('/myshop/seller/jobtodo');
        } else {
          navigate('/marketplace?category=รวมสินค้า');
        }
      }
    }
  }

  function showDialogCallback_General() {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm() {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    navigate('/');
  }

  return (
    <div className='footer mt-0'>
      <div className='pt-2 pb-2 footer-body mt-0'>
        <div className='container'>
          <div className='d-block d-md-flex justify-content-between'>
            <div className='d-block'>
              <br />
              <div className='d-flex align-items-start mb-2'>
                <Link to='/marketplace?category=รวมสินค้า'>
                  <img src={meya_logo} alt='MEYA' className='footer-logo' />
                </Link>
                <div className='footer-word'>
                  <h5 className='mb-1 text-primary font-th'>
                    มียา <strong className=''>MEYA</strong>
                  </h5>
                  <h5 className='font-size-14 text-gray-90 font-th'>
                    พื้นที่แลกเปลี่ยนสินค้าสำหรับผู้ประกอบการธุรกิจ ด้านสุขภาพ <br />
                    ที่ได้รับใบอนุญาต เช่น ร้านขายยา คลินิก สถานพยาบาล <br />
                    โรงพยาบาล คลินิกสัตว์แพทย์ คลินิกทันตกรรม
                  </h5>
                </div>
              </div>
            </div>

            <div className='d-block'>
              <br />
              <div className='footer-right-box justify-content-between'>
                <div className='footer-navigate'>
                  <h6 className='mb-1 font-weight-bold font-th'>เกี่ยวกับเรา</h6>
                  <ul className='list-group list-group-flush list-group-borderless mb-0 list-group-transparent'>
                    {/* <li>
                      <Link className='list-group-item list-group-item-action font-th' to='/home'>
                        หน้าแรก
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        className='list-group-item list-group-item-action font-th'
                        onClick={() => {
                          security_protection('buyer');
                        }}
                      >
                        หน้าแรก
                      </Link>
                    </li>
                    {props.islogin === false && props.permitdata !== null ? (
                      props.permitdata.role !== 'guest' && props.permitdata.token !== '' ? (
                        <li>
                          <Link
                            className='list-group-item list-group-item-action font-th'
                            onClick={() => {
                              security_protection('seller');
                            }}
                          >
                            ขายสินค้ากับเรา
                          </Link>
                        </li>
                      ) : null
                    ) : null}
                    <li>
                      <Link className='list-group-item list-group-item-action font-th' to='/about'>
                        เกี่ยวกับเรา
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className='footer-contact'>
                  <h6 className='mb-1 font-weight-bold font-th'>ติดต่อเรา</h6>
                  <ul className='list-group list-group-flush list-group-borderless mb-0 list-group-transparent'>
                    <li>
                      <a
                        className='list-group-item list-group-item-action font-th'
                        href='https://www.google.com/maps/search/?api=1&query=บริษัท+มียามียา+จำกัด'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <i className='text-dark ec ec-map-pointer mr-1'></i> บริษัท มียามียา
                        จำกัด
                      </a>
                    </li>

                    <li>
                      <a
                        className='list-group-item list-group-item-action font-th'
                        href='mailto:contact@meyameya.me'
                      >
                        <i className='text-dark ec ec-mail mr-1'></i> contact@meyameya.me
                      </a>
                    </li>

                    <li>
                      <a
                        className='list-group-item list-group-item-action font-th'
                        href='tel:0979966908'
                      >
                        <i className='text-dark ec ec-phone mr-1'></i> 097-996-6908
                      </a>
                    </li>
                    <li>
                      <a
                        className='list-group-item list-group-item-action font-th'
                        href='https://lin.ee/G3gOv00'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <i class="fab fa-line text-dark mr-1"></i> Line OA : @meya
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='footer-copyright py-2'>
        <div className='container'>
          <div className='flex-center-between d-block d-md-flex'>
            <div className='mb-md-0'>
              © 2023 Copyright :{' '}
              <Link to='/home' className='font-weight-bold text-gray-90'>
                MEYA
              </Link>
            </div>
          </div>
        </div>
      </div>

      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

export default Footer;
